<template>
    <div class="EndPageSetting">
        <div class="select-box">
            <el-select 
                v-model="paper.endPageType" 
                :placeholder="$t('main.PleaseSelect')"
                size="mini"
            >
                <el-option
                  :label="$t('main.NormalCompletion')"
                  :value="0">
                </el-option>
                <el-option
                    v-if="type == 'wj'"
                  :label="$t('main.EarlyTerminationDoesNotCountTowardsResults')"
                  :value="1">
                </el-option>
            </el-select> {{$t('main.ShowWhen')}}
        </div>
        <div class="content-editable" @click="setActiveInput(paper.endPageType == 0? 'endPageNormalMsg': 'endPageAdvanceMsg')">
            <TitleEditor
                :qid="'endPageNormalMsg'"
                :class="'endPageNormalMsg'"
                v-if="paper.endPageType == 0"
                key="endPageNormalMsg"
                class="titleEditor"
                :value="paper.endPageNormalMsg"
                :actionTitleEditorShow="activeInputId === 'endPageNormalMsg'"
                @childValueChange="
                    val => {
                        paper.endPageNormalMsg = val;
                    }
                "
            ></TitleEditor>
            
            <TitleEditor
                :qid="'endPageAdvanceMsg'"
                :class="'endPageAdvanceMsg'"
                v-if="paper.endPageType == 1"
                key="endPageAdvanceMsg"
                class="titleEditor"
                :value="paper.endPageAdvanceMsg"
                :actionTitleEditorShow="activeInputId === 'endPageAdvanceMsg'"
                @childValueChange="
                    val => {
                        paper.endPageAdvanceMsg = val;
                    }
                "
            ></TitleEditor>
        </div>
    </div>
</template>
<script>
// 设计页面 结束页 设置
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import { mapActions, mapState } from "vuex"
export default {
    name: 'EndPageSetting',
    components: {
        TitleEditor
    },
    props: {
        paper: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            value: '',
        }
    },
    computed:{
		...mapState(['activeInputId']),
	},
    created(){
    },
    methods:{
        ...mapActions(['setActiveInput']),
    }
}
</script>

<style scoped lang="scss">
.EndPageSetting{
    margin-top: 24px;
    padding: 22px 70px 100px;
    background-color: #fff;
    border-radius: 4px;
    text-align: center;
	margin-bottom: 70px;
    .select-box{
        margin-bottom: 18px;
        font-size: 12px;
    }
    .content-editable{
        width: 100%;
        margin: 6px 10px;
        font-size: 16px;
        line-height: 1.4;
        box-sizing: border-box;
        border-radius: 2px;
        border: 1px dashed transparent;
        position: relative;
    }
    .content-editable:hover{
        border: 1px dashed rgba(0,0,0,.4);
    }
}
</style>
